<template>
    <layout :title="travelInfo.destination" :banner="$page.props.banner" h1="Urlaubsziel" metaDescription="Hier gibt es alle Informationen rund um deine Reise. Buche deine Reise direkt über unsere Website." metaKeywords="SCOL, SCOL Angebote, Skireisen Angebote, SCOL Winterurlaub, Skiurlaub Winter, Skifahren Österreich, Kals am Großglockner, Fügen, Hochfügen, Kaltenbach, Ried, Corvara, Saalbach, Serfaus, Sölden, Bad Hofgastein, Ischgl">
        <section id="urlaubsziel" class="scol-section bg-vacation-blue">
            <div class="container-large">
                <div class="text-center">
                    <h2 class="text-secondary">{{ travelInfo.destination }}</h2>
                    <p>
                        <small>Gut geeignet für</small>
                        <br />
                    <div>
                        <span class="text-primary mx-1" v-for="tag in travelInfo.tags">#{{ tag.name.de }}</span>
                    </div>
                    </p>
                </div>

                <div class="row mt-4">
                    <div class="col-12 col-xxl-4 mb-4 mb-xxl-0">
                        <div class="h-100 p-4 vacation-bg">
                            <h2 class="text-secondary">Infos</h2>
                            <p v-html="travelInfo.description"></p>
                            <div class="row text-secondary mt-1 g-4">
                                <div class="col-sm-6 col-xl-12 col-xxl-6">
                                    <div class="d-flex align-items-start">
                                        <img class="information-icon" src="/images/icons/icon-mountain-ski-secondary.svg" alt="Icon Berg" />
                                        <p class="lh-sm">
                                            <small>Skigebiet: {{ travelInfo.skiarea_height_from }} bis {{ travelInfo.skiarea_height_to }} m</small>
                                        </p>
                                    </div>
                                </div>
                                <div class="col-sm-6 col-xl-12 col-xxl-6">
                                    <div class="d-flex align-items-start">
                                        <img class="information-icon" src="/images/icons/icon-person-ski-secondary.svg" alt="Icon Person auf Ski" />
                                        <p class="lh-sm">
                                            <small>Pisten: {{ travelInfo.skitrack }} km {{ travelInfo.skitrack_comment }}</small>
                                        </p>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6 col-xl-12 col-xxl-6">
                                    <div class="d-flex align-items-start">
                                        <img class="information-icon" src="/images/icons/icon-certificate-document-secondary.svg" alt="Icon Dokument Zertifikat" />
                                        <p class="lh-sm">
                                            <small>Ski Alpin Testnote: {{ travelInfo.ski_alpine_rating }}* {{ travelInfo.ski_alpine_rating_comment }}</small>
                                        </p>
                                    </div>
                                </div>
                                <div v-if="travelInfo.apres_ski_rating || travelInfo.apres_ski_rating_comment" class="col-12 col-sm-6 col-xl-12 col-xxl-6">
                                    <div class="d-flex align-items-start">
                                        <p class="lh-sm">
                                            <img class="information-icon" src="/images/icons/icon-apre-ski.svg" alt="Icon Aprè Ski" />
                                            <small>Après Ski Testnote: {{ travelInfo.apres_ski_rating }}* {{ travelInfo.apres_ski_rating_comment }}</small>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-xxl-4">
                        <img class="info-section-image" alt="SCOL Skireisen - Urlaubsziel Teaser" :src="travelInfo.teaserMediumUrls[0]" />
                    </div>
                    <div class="col-sm-6 col-xxl-4 mt-4 mt-sm-0">
                        <img class="info-section-image" alt="SCOL Skireisen - Urlaubsziel Teaser" v-if="travelInfo.teaserMediumUrls[1]" :src="travelInfo.teaserMediumUrls[1]" />
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col">
                        <div class="text-center">
                            <!-- Partyreise: Kurzanfrage über die Aktionsseite statt Buchungsmaske -->
                            <Link v-if="travelInfo.code === 'FUEGENPARTY'" class="btn btn-primary rounded-pill" :href="$route('campaign')"><i class="fa-solid fa-pen-to-square"></i> Jetzt registrieren</Link>
                            <a v-else class="btn btn-primary rounded-pill" href="#termine"><i class="fa-solid fa-calendar-days"></i> Jetzt buchen</a>
                            <a v-if="shorties.length && travelInfo.code !== 'SOELDEN'" class="btn btn-outline-primary rounded-pill ms-2" href="#shorties"><i class="fa-solid fa-calendar-days"></i> Shorties</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="info-tabs" class="scol-section pt-0">
            <div class="bg-light-grey">
                <div class="container container-small">
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#kurzinfo" type="button">
                                Kurzinfo
                            </button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" data-bs-toggle="tab" data-bs-target="#leistungen" type="button">
                                Leistungen
                            </button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" data-bs-toggle="tab" data-bs-target="#skigebiet" type="button">
                                Skigebiet
                            </button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" data-bs-toggle="tab" data-bs-target="#urlaubsort" type="button">
                                Urlaubsort
                            </button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" data-bs-toggle="tab" data-bs-target="#unterkunft" type="button">
                                Unterkunft
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="container container-small tab-content py-4">
                <div class="tab-pane fade show active" id="kurzinfo" role="tabpanel">
                    <div v-html="travelInfo.description_short"></div>

                    <div class="mt-4" v-if="travelInfo.description_short_rooms">
                        <div id="kurzinfo-zimmer">
                            <div class="table-scrollable" v-html="travelInfo.description_short_rooms"></div>
                        </div>
                    </div>

                    <div class="mt-4">
                        <h3>Weitere Informationen:</h3>
                        <div v-html="travelInfo.description_short_additional"></div>
                    </div>

                    <div class="mt-4" v-if="boardings">
                        <h3>Anreiseinfos</h3>
                        <div class="d-flex mt-4">
                            <div v-for="boarding in boardings" class="travel-boarding-infos text-center">
                                <div v-if="boarding.type == 'bus'" class="me-4">
                                    <a href="/anreise" class="text-decoration-none text-dark link-primary">
                                        <i class="fa-solid fa-bus"></i>
                                        <span class="d-block display-6 mt-2">Bus</span>
                                    </a>
                                </div>
                                <div v-if="boarding.type == 'seperate'">
                                    <a href="/anreise#pkw" class="text-decoration-none text-dark link-primary">
                                        <i class="fa-solid fa-car"></i>
                                        <span class="d-block display-6 mt-2">eigene Anreise</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" id="leistungen" role="tabpanel">
                    <div v-html="travelInfo.description_services"></div>
                </div>
                <div class="tab-pane fade" id="skigebiet" role="tabpanel">
                    <div v-if="travelInfo.skiareaUrls.length" class="mb-4 skigebiet-img-wrapper">
                        <LightboxGallery :images="travelInfo.skiareaUrls" :previews="travelInfo.skiareaPreviewUrls" altTag="Skigebiet"></LightboxGallery>
                    </div>

                    <div v-html="travelInfo.description_skiarea"></div>
                </div>
                <div class="tab-pane fade" id="urlaubsort" role="tabpanel">
                    <div v-html="travelInfo.description_location"></div>
                </div>
                <div class="tab-pane fade" id="unterkunft" role="tabpanel">
                    <div v-html="travelInfo.description_accomodation"></div>
                </div>
            </div>
        </section>

        <section v-if="shorties.length && travelInfo.code == 'SOELDEN'" id="shorties" class="scol-section bg-light-grey">
            <div class="scol-section-caption">
                <h2>Opening</h2>
            </div>
            <div class="container container-small">
                <div class="bg-white p-3 p-md-4 p-xl-5">
                    <!-- <div class="table-scrollable">
                        <table class="table table-appointments">
                            <thead>
                                <tr>
                                    <th scope="col" class="border-bottom border-primary"><h3 class="mb-1">Reisedatum</h3></th>
                                    <th scope="col" class="border-bottom border-primary"><h3 class="mb-1">Preis</h3></th>
                                    <th scope="col" class="border-bottom border-primary"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="shorty in shorties">
                                    <tr v-for="shorty_date in shorty.dates" :key="'shorty_date-' + shorty_date.id">
                                        <th scope="row">{{ shorty_date.timespan }}</th>
                                        <td> ab <price :given="shorty_date.priceFrom" /></td>
                                        <td class="text-end py-2 py-xl-3">
                                            <Link v-if="!shorty_date.bookedOut" :href="$route('booking.step2', shorty_date.slug)" class="btn btn-travel-destination btn-sm btn rounded-pill btn-primary"><i class="fa-solid fa-chevron-right"></i> Buchen</Link>
                                            <Link v-if="shorty_date.bookedOut" :href="$route('contact')" class="btn btn-sm btn-travel-destination rounded-pill btn-secondary">Ausgebucht</Link>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div> -->



                    <div class="row pb-3">
                        <div class="col-6">
                            <h3 class="mb-1">Reisedatum</h3>
                        </div>
                        <div class="col-6 col-sm-4">
                            <h3 class="mb-1">Preis</h3>
                        </div>
                        <hr class="mt-2 mb-0 border-primary" />
                    </div>
                    <template v-for="shorty in shorties">
                        <div class="row pb-3" v-for="shorty_date in shorty.dates" :key="'shorty_date-' + shorty_date.id">
                            <div class="col-6 fw-bold d-flex align-items-center"><span>{{ shorty_date.timespan }}</span></div>
                            <div class="col-6 col-sm-4 d-flex align-items-center"><span v-if="shorty_date.priceFrom">ab
                                    <price :given="shorty_date.priceFrom" />
                                </span></div>
                            <div class="col-12 col-sm-2 d-flex justify-content-center justify-content-sm-end mt-3 mt-sm-0">
                                <Link v-if="!shorty_date.bookedOut && shorty_date.priceFrom" :href="$route('booking.step2', shorty_date.slug)" class="btn btn-travel-destination btn-sm rounded-pill btn-primary">Buchen</Link>
                                <Link v-else :href="generateLink(shorty_date)" class="btn btn-sm btn-travel-destination rounded-pill btn-secondary">Auf Anfrage</Link>
                            </div>
                            <hr class="mt-2 mb-0" />
                        </div>
                    </template>
                </div>
            </div>
        </section>

        <section id="termine" class="scol-section bg-light">
            <div class="scol-section-caption">
                <h2>Termine</h2>
            </div>
            <div class="container container-small">
                <div class="bg-white p-3 p-md-4 p-xl-5">
                    <!-- <div class="table-scrollable">
                        <table class="table table-appointments">
                            <thead>
                                <tr>
                                    <th scope="col" class="border-bottom border-primary"><h3 class="mb-1">Reisedatum</h3></th>
                                    <th scope="col" class="border-bottom border-primary"><h3 class="mb-1">Preis</h3></th>
                                    <th scope="col" class="border-bottom border-primary"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="travel_date in travelInfo.dates" :key="'travel_date-' + travel_date.id">
                                    <th scope="row">{{ travel_date.timespan }}</th>
                                    <td> ab <price :given="travel_date.priceFrom" /></td>
                                    <td class="text-end py-2">
                                        <Link v-if="!travel_date.bookedOut" :href="$route('booking.step2', travel_date.slug)" class="btn btn-travel-destination btn-sm rounded-pill btn-primary">Buchen</Link>
                                        <Link v-if="travel_date.bookedOut" :href="$route('contact')" class="btn btn-sm btn-travel-destination rounded-pill btn-secondary">Ausgebucht</Link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div> -->
                    <div class="row pb-3">
                        <div class="col-6">
                            <h3 class="mb-1">Reisedatum</h3>
                        </div>
                        <div class="col-6 col-sm-4">
                            <h3 class="mb-1">Preis</h3>
                        </div>
                        <hr class="mt-2 mb-0 border-primary" />
                    </div>

                    <div v-if="dates.length">
                        <div class="row pb-3" v-for="travel_date in dates" :key="'travel_date-' + travel_date.id">
                            <div class="col-6 fw-bold d-flex align-items-center"><span>{{ travel_date.timespan }}</span></div>
                            <div class="col-6 col-sm-4 d-flex align-items-center"><span v-if="travel_date.priceFrom">ab
                                    <price :given="travel_date.priceFrom" />
                                </span></div>
                            <div class="col-12 col-sm-2 d-flex justify-content-center justify-content-sm-end mt-3 mt-sm-0">
                                <Link v-if="!travel_date.bookedOut && travel_date.priceFrom" :href="$route('booking.step2', travel_date.slug)" class="btn btn-travel-destination btn-sm rounded-pill btn-primary">Buchen</Link>
                                <Link v-else :href="generateLink(travel_date)" class="btn btn-sm btn-travel-destination rounded-pill btn-secondary">Auf Anfrage</Link>
                            </div>
                            <hr class="mt-2 mb-0" />
                        </div>
                    </div>

                    <div class="row" v-if="!dates.length">
                        <div class="col-12">
                            Aktuell gibt es keine Termine
                        </div>
                    </div>

                    <!--
                        CTA für eine individuelle Anfrage, wenn der gewünschte
                        Reisezeitraum nicht angeboten wird. Bei den eigenen SCOL
                        Hotels Kals (KALS) und Fügen (FUEGEN) wird der CTA nicht
                        angezeigt.
                    -->
                    <div
                        v-if="travelInfo.code !== 'KALS' && travelInfo.code !== 'FUEGEN'"
                        class="row mt-4 pt-4 border-top"
                    >
                        <div class="col-12 text-center">
                            <p class="mb-3 fw-bold">Reisezeitraum nicht dabei?</p>
                            <Link :href="inquiryLink" class="btn btn-primary rounded-pill">
                                <i class="far fa-paper-plane me-2"></i> Jetzt anfragen!
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>




        <section v-if="shorties.length && travelInfo.code !== 'SOELDEN'" id="shorties" class="scol-section bg-light-grey">
            <div class="scol-section-caption">
                <h2>Shorties</h2>
            </div>
            <div class="container container-small">
                <div class="bg-white p-3 p-md-4 p-xl-5">
                    <!-- <div class="table-scrollable">
                        <table class="table table-appointments">
                            <thead>
                                <tr>
                                    <th scope="col" class="border-bottom border-primary"><h3 class="mb-1">Reisedatum</h3></th>
                                    <th scope="col" class="border-bottom border-primary"><h3 class="mb-1">Preis</h3></th>
                                    <th scope="col" class="border-bottom border-primary"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="shorty in shorties">
                                    <tr v-for="shorty_date in shorty.dates" :key="'shorty_date-' + shorty_date.id">
                                        <th scope="row">{{ shorty_date.timespan }}</th>
                                        <td> ab <price :given="shorty_date.priceFrom" /></td>
                                        <td class="text-end py-2 py-xl-3">
                                            <Link v-if="!shorty_date.bookedOut" :href="$route('booking.step2', shorty_date.slug)" class="btn btn-travel-destination btn-sm btn rounded-pill btn-primary"><i class="fa-solid fa-chevron-right"></i> Buchen</Link>
                                            <Link v-if="shorty_date.bookedOut" :href="$route('contact')" class="btn btn-sm btn-travel-destination rounded-pill btn-secondary">Ausgebucht</Link>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div> -->



                    <div class="row pb-3">
                        <div class="col-6">
                            <h3 class="mb-1">Reisedatum</h3>
                        </div>
                        <div class="col-6 col-sm-4">
                            <h3 class="mb-1">Preis</h3>
                        </div>
                        <hr class="mt-2 mb-0 border-primary" />
                    </div>
                    <template v-for="shorty in shorties">
                        <div class="row pb-3" v-for="shorty_date in shorty.dates" :key="'shorty_date-' + shorty_date.id">
                            <div class="col-6 fw-bold d-flex align-items-center"><span>{{ shorty_date.timespan }}</span></div>
                            <div class="col-6 col-sm-4 d-flex align-items-center"><span v-if="shorty_date.priceFrom">ab
                                    <price :given="shorty_date.priceFrom" />
                                </span></div>
                            <div class="col-12 col-sm-2 d-flex justify-content-center justify-content-sm-end mt-3 mt-sm-0">
                                <Link v-if="!shorty_date.bookedOut && shorty_date.priceFrom" :href="$route('booking.step2', shorty_date.slug)" class="btn btn-travel-destination btn-sm rounded-pill btn-primary">Buchen</Link>
                                <Link v-else :href="generateLink(shorty_date)" class="btn btn-sm btn-travel-destination rounded-pill btn-secondary">Auf Anfrage</Link>
                            </div>
                            <hr class="mt-2 mb-0" />
                        </div>
                    </template>
                </div>
            </div>
        </section>


        <section v-if="travelInfo.galleryUrls.length" id="galerie" class="scol-section bg-white">
            <div class="scol-section-caption">
                <h2>Galerie</h2>
            </div>
            <div class="container-large pt-4 pt-xl-5 scol-section">
                <Carousel :settings="galerie" :breakpoints="breakpoints">
                    <Slide v-for="(galleryUrl, i) in travelInfo.galleryMediumUrls" :key="slide">
                        <div class="carousel__item" :style="{ backgroundImage: 'url(\'' + galleryUrl + '\')' }" @click="showImg(i)" role="button"></div>
                    </Slide>
                    <template #addons>
                        <Navigation />
                    </template>
                </Carousel>

                <vue-easy-lightbox :visible="visibleRef" :imgs="imgsRef" :index="indexRef" @hide="onHide"></vue-easy-lightbox>
            </div>
        </section>




        <section id="passende-angebote" class="scol-section bg-light-grey">
            <div class="scol-section-caption">
                <h2>Weitere Angebote</h2>
            </div>
            <div class="container-large scol-section-xs scol-section-mobile">
                <div class="row justify-content-around gx-lg-5">
                    <div class="col-sm-6 col-lg-4 col-xxl-3 mb-4" v-for="deal in deals" :key="'deal-' + deal.id">
                        <scol-travel-preview class="bg-white" :model="deal" />
                    </div>
                </div>
            </div>
        </section>
    </layout>
</template>

<script>
import Layout from "./Layouts/Standard";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Navigation } from "vue3-carousel";
import { Link } from "@inertiajs/inertia-vue3";
import ScolTravelPreview from "../Components/Scol/TravelPreview";
import VueEasyLightbox from "vue-easy-lightbox";
import LightboxGallery from "../Components/Scol/LightboxGallery.vue";
import Price from "../Components/Scol/Price";
import { ref } from "vue";

export default {
  components: {
    Layout,
    Carousel,
    Slide,
    Navigation,
    Link,
    ScolTravelPreview,
    VueEasyLightbox,
    LightboxGallery,
    Price,
  },
  data: () => ({
    requestData: "asd",
    info: {
      itemsToShow: 2,
      snapAlign: "start",
      breakpoints: {
        700: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 2,
          snapAlign: "start",
        },
      },
    },
    galerie: {
      itemsToShow: 1,
      wrapAround: true,
      snapAlign: "start",
      arrows: true,
      breakpoints: {
        576: {
          itemsToShow: 2,
        },
        1024: {
          itemsToShow: 3,
        },
      },
    },
  }),
  computed: {
    // Link zur Anfrage-Seite, vorbefüllt mit dem aktuellen Reiseziel.
    inquiryLink() {
      const param = encodeURIComponent(this.travelInfo.destination);
      return `${this.$route("inquiry")}/?reiseziel=${param}`;
    },
  },
  methods: {
    generateLink(travelDate) {
      const param = encodeURIComponent(travelDate.subtitle);
      const baseLink = this.constructRoute();
      return `${baseLink}/?reiseziel=${param}`;
    },
    constructRoute() {
      return this.$route("inquiry");
    },
    formatDate(date) {
      // Format the date as "d.m.Y"
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();

      return `${day}.${month}.${year}`;
    },
  },
  props: {
    travelInfo: Object,
    boardings: Object,
    rooms: Object,
    dates: Object,
    shorties: Object,
    deals: Object,
  },
  // Lightbox
  setup(props) {
    const visibleRef = ref(false);
    const indexRef = ref(0);
    const imgsRef = ref(props.travelInfo.galleryUrls);

    const onShow = () => {
      visibleRef.value = true;
    };
    const showImg = (index) => {
      indexRef.value = index;
      visibleRef.value = true;
      onShow();
    };
    const onHide = () => (visibleRef.value = false);

    return {
      visibleRef,
      indexRef,
      imgsRef,
      showImg,
      onHide,
    };
  },
};
</script>
